import { Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'

import { useStyles } from './../styles'
import { Loader } from 'src/components/loader'
import { ScannerButton } from 'src/components/scanners/common'
import { CircleAlertIcon } from 'src/assets/icons'
import { useState } from 'react'

interface IProps {
  open: boolean
  handleClose: () => void
  handleProceed: () => void
  isProceeding: boolean
  barcodeId: string
  priceAmount: number
}

export const FormSubmitVerifyModal = ({
  open,
  handleClose,
  handleProceed,
  isProceeding,
  barcodeId,
  priceAmount,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  const [isFormSubmitting, setIsFormSubmitting] = useState(false)

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.verifyModal}>
      <Box className={classes.formVerifySubmitDetailswrapper}>
        <CircleAlertIcon className={classes.formVerifySubmitDetailsIcon} />
        <Grid>
          <Typography className={classes.formVerifySubmitDetailsTitle}>
            {'Are you sure you want to proceed?'}
          </Typography>
        </Grid>
        <Grid>
          <Typography className={classes.formVerifySubmitDetailsText}>
            {`Thank you for scanning `}
            <strong>{barcodeId}</strong>
            {`! You will receive `}
            <strong>{priceAmount}</strong>
            {` points once your scan has been verified. Scan another product to continue earning!`}
          </Typography>
        </Grid>
      </Box>
      <div className={classes.buttonsWrapper}>
        <ScannerButton
          disabled={isProceeding}
          type="submit"
          onClick={() => {
            setIsFormSubmitting(() => true)
            handleProceed()
          }}
          text={
            isProceeding ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                {t('confirm-button-text.v')} <Loader size={20} isStatic />
              </Box>
            ) : (
              t('confirm-button-text.v')
            )
          }
        />
        <ScannerButton
          disabled={isFormSubmitting}
          onClick={handleClose}
          text={t('scan-form-submit-text-1.v')}
          color="dark"
        />
      </div>
    </ModalWrapper>
  )
}
